import ResultsTable from "./ResultTable";

export default ResultsTable;
